import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import CommonTextField from "../../Components/Common/CommonTextField";
import TextLabel from "../../Components/Common/CommonTextLabel";
import ButtonContained from "../../Components/Common/ButtonContained.js";
import { Regex } from "../../Utils/regex.js";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import {
  getAvailableAccess,
  login,
  verifyOtp,
} from "../../Redux/Actions/action.js";
import ErrorHandler, { getValuebyId } from "../../Utils/handler.js";
import { toast } from "react-toastify";
import sessionStoreUtil from "../../ApiSetup/Localstorage.js";
import { showLoader } from "../../Redux/Slices/loaderSlice.js";

const Login = () => {
  // ---------- Hook -----------
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // --------------- State -------------
  const [data, setData] = useState({
    phoneNumber: "",
  });
  const [error, setError] = useState({});
  const [otp, setOtp] = useState("");

  // ----------- handelChange ---------------
  const validation = () => {
    const errors = {};
    let valid = true;

    if (!data?.phoneNumber) {
      errors.phoneNumber = "please enter your phone number";
      valid = false;
    }
    // if (!data?.role) {
    //     errors.role = "please selct your role";
    //     valid = false;
    // }
    if (data?.phoneNumber && !Regex.mobileNumberRegex.test(data?.phoneNumber)) {
      errors.mobileValid = "please enter a valid mobile number";
      valid = false;
    }
    if (otp) {
      if (!data.otp) {
        errors.otp = "Please enter otp";
        valid = false;
      }
    }

    setError(errors);
    return valid;
  };

  // ----------- Api -------------
  const _onSubmitOtp = async () => {
    if (validation()) {
      dispatch(showLoader(true));
      let body = {
        phoneNumber: data?.phoneNumber,
        // userType: getValuebyId(data?.role, loginRole)
      };

      try {
        const result = await dispatch(login(body));
        const error = ErrorHandler(result);
        if (error) {
          toast.success(result?.payload?.message);
          setOtp(result?.payload?.status);
        }
      } catch (error) {
        toast.error(error?.message || "An unknown error occurred");
      } finally {
        dispatch(showLoader(false));
      }
    }
  };

  const _onSubmit = async () => {
    if (validation()) {
      dispatch(showLoader(true));
      let body = {
        phoneNumber: data.phoneNumber,
        otp: +data?.otp,
        // userType: getValuebyId(data?.role, loginRole)
      };

      try {
        const result = await dispatch(verifyOtp(body));
        const error = ErrorHandler(result);
        if (error) {
          toast.success(result?.payload?.message);
          sessionStoreUtil.setLSItem(
            "auth_token",
            result?.payload?.data?.user?.accessToken
          );
          sessionStoreUtil.setLSItem(
            "userData",
            JSON.stringify(result?.payload?.data?.user)
          );
          setData({});
          _getAvailableAccess();
        }
      } catch (error) {
        toast.error(error?.message || "An unknown error occurred");
      } finally {
        dispatch(showLoader(false));
      }
    }
  };

  const _getAvailableAccess = () => {
    dispatch(showLoader(true));
    dispatch(getAvailableAccess())
      .then((data) => {
        const error = ErrorHandler(data);
        if (error) {
          const mainMenu = data?.payload?.data?.result?.filter((menu) =>
            ["Dashboard", "Add Member"].includes(menu?.pageName)
          );
          const claimsMenu = data?.payload?.data?.result?.filter((menu) =>
            [
              "Member Requests",
              "Documents",
              "Claims",
              "Member Search",
            ].includes(menu?.pageName)
          );
          const otherMenu = data?.payload?.data?.result?.filter(
            (menu) =>
              ![
                "Dashboard",
                "Add Member",
                "Member Requests",
                "Documents",
                "Claims",
                "Member Search",
              ].includes(menu?.pageName)
          );
          if (mainMenu?.length > 0) {
            navigate(mainMenu?.[0]?.path);
          } else if (claimsMenu?.length > 0) {
            navigate(claimsMenu?.[0]?.path);
          } else if (otherMenu?.length > 0) {
            navigate(otherMenu?.[0]?.path);
          }
        }
      })
      .catch((error) => console.error("error", error))
      .finally(() => dispatch(showLoader(false)));
  };
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        minWidth={"30vh"}
        sx={{
          backgroundImage: "url(/images/login.png)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          color: "#FFFFFF",
        }}
      >
        <Grid
          container
          spacing={isMobile ? 1 : 2}
          maxWidth={isMobile ? "80%" : "584px"}
          maxHeight={isMobile ? "100%" : "450px"}
          padding={isMobile ? "25px 20px 25px 20px" : "35px"}
          borderRadius="20px"
          sx={{
            backgroundColor: "#FFFFFF",
            backgroundImage: "url(/images/Dot.png)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center bottom",
          }}
        >
          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            mb={isMobile ? "25px" : "20px"}
            padding={"0px !important"}
          >
            <Typography
              fontSize={isMobile ? "20px" : "28px"}
              fontWeight={600}
              lineHeight={isMobile ? "1.9rem" : "1.9rem"}
              letterSpacing="-1px"
              color={"#3E4095"}
            >
              Login to Admin Panel
            </Typography>
          </Grid>

          {/* Form Fields */}
          <Grid item container xs={12} padding={"0px !important"}>
            {/* <Grid item xs={12} mb={{ xs: "15px", md: "20px" }}>
                            <CommonDropDown
                                type="text"
                                text={'Role'}
                                labelColor={"#3E4095B2"}
                                name={'role'}
                                value={data?.role || ""}
                                values={loginRole?.map((e) => e?.label) || []}
                                placeholder={`Select Role`}
                                width={"100%"}
                                valid
                                onChange={(e) => {
                                    const { value } = e?.target
                                    setData((prevValue) => ({
                                        ...prevValue,
                                        role: value,
                                    }));
                                }}
                            />
                            <TextLabel
                                color='error'
                                title={!data?.role ? error.role : ""}
                            />
                        </Grid> */}

            <Grid item xs={12} mb={{ xs: "15px", md: "20px" }}>
              <CommonTextField
                value={data?.phoneNumber}
                labelColor={"#3E4095B2"}
                width={"100%"}
                text="Phone Number"
                type="number"
                placeholder="Enter phone number"
                name="phoneNumber"
                valid
                onChange={(e) => {
                  const { value } = e.target;
                  if (/^(?!0{2,})\d*$/.test(value) && value.length <= 10) {
                    setData((prevValue) => ({
                      ...prevValue,
                      phoneNumber: value,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    _onSubmitOtp();
                  }
                }}
              />
              <TextLabel
                color="error"
                title={!data?.phoneNumber ? error.phoneNumber : ""}
              />
              <TextLabel
                color="error"
                title={
                  data?.phoneNumber
                    ? !Regex?.mobileNumberRegex?.test(data?.phoneNumber)
                      ? error.mobileValid
                      : ""
                    : ""
                }
              />
            </Grid>

            {otp && (
              <Grid item xs={12} mb={{ xs: "15px", md: "20px" }}>
                <CommonTextField
                  value={data?.otp}
                  labelColor={"#3E4095B2"}
                  width={"100%"}
                  text="OTP"
                  type="text"
                  placeholder="Enter OTP"
                  name="otp"
                  valid
                  onChange={(e) => {
                    const { value } = e.target;
                    if (/^(?!0{2,})\d{0,6}$/.test(value) && value.length <= 6) {
                      setData((prevValue) => ({
                        ...prevValue,
                        otp: value,
                      }));
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      _onSubmit();
                    }
                  }}
                />
                <TextLabel color="error" title={!data?.otp ? error.otp : ""} />
              </Grid>
            )}

            {/* Login Button */}
            <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
              {otp ? (
                <ButtonContained
                  text={"Log in"}
                  fullWidth
                  onClick={_onSubmit}
                />
              ) : (
                <ButtonContained
                  text={"Send OTP"}
                  fullWidth
                  onClick={_onSubmitOtp}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Login;
